import { combineReducers } from 'redux';
import selectedField from './selected-field/reducer';

export default combineReducers({
    selectedField,
});
